<template>
  <dl class="text-center text-muted">
    <dt>Estat</dt>
    <dd v-html="proyecto.es_actiu ? 'Actiu' : 'Inactiu'"></dd>
    <dt class="text-body">Dedicacions</dt>
    <dd class="text-body" :class="{ 'font-italic': !proyecto.dedicaciones }" v-html="proyecto.dedicaciones ? `${formatearDecimales(proyecto.dedicaciones)} hores` : 'Sense dedicacions'"></dd>
    <dt class="text-body">Despeses</dt>
    <dd class="text-body" :class="{ 'font-italic': !proyecto.gastos }" v-html="proyecto.gastos ? `${formatearDecimales(proyecto.gastos)}€` : 'Sense despeses'"></dd>
    <dt>Tipus</dt>
    <dd>{{ proyecto.tipus }}</dd>
    <dt>Responsable</dt>
    <dd :class="{ 'font-italic': !proyecto.nombre_completo }" v-html="proyecto.nombre_completo ? proyecto.nombre_completo : 'Sense definir'"></dd>
    <dt>Previsió hores:</dt>
    <dd>
      <ul v-if="proyecto.horas_previstas" class="d-inline-block text-left">
        <li v-for="(prevision, index) in proyecto.horas_previstas" :key="index">{{ prevision.perfil }}: {{ prevision.cantidad }}</li>
      </ul>
      <i v-else>Sense definir</i>
    </dd>
    <dt>Previsió costos</dt>
    <dd :class="{ 'font-italic': !proyecto.previsio_costos }" v-html="proyecto.previsio_costos != null ? `${formatearDecimales(proyecto.previsio_costos)}€` : 'Sense definir'"></dd>
    <dt>Marge Comercial</dt>
    <dd :class="{ 'font-italic': !proyecto.marge_comercial }" v-html="proyecto.marge_comercial != null ? `${formatearDecimales(proyecto.marge_comercial)}%` : 'Sense definir'"></dd>
  </dl>
</template>

<script>
export default {
  components: {},
  name: "DesgloseProyecto",
  inject: ["formatearDecimales"],
  props: {
    proyecto: Object,
  },
};
</script>